export default __webpack_public_path__ + "static/media/outside.a625cd5b.png";